module.exports = __webpack_public_path__ + "static/img/statistics_normal.591b9709.png";